
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.667 9.083c0 .634.141 1.25.4 1.884a2.935 2.935 0 00-1.267 1.2c-.508-1-.8-2.017-.8-3.084 0-3.083 2.417-5.5 5.5-5.5 1.742 0 3.408.809 4.5 2.092 1.092-1.283 2.758-2.092 4.5-2.092 3.083 0 5.5 2.417 5.5 5.5 0 1.067-.292 2.084-.792 3.084a2.91 2.91 0 00-1.275-1.2c.259-.634.4-1.25.4-1.884A3.792 3.792 0 0016.5 5.25c-1.999 0-2.965 1.158-4.073 2.485-.14.167-.281.336-.427.507-.137-.161-.27-.32-.402-.478C10.471 6.414 9.501 5.25 7.5 5.25a3.792 3.792 0 00-3.833 3.833zM20.983 16.567a5.792 5.792 0 00-2.316-.484 5.82 5.82 0 00-.942.084c.333.566.525 1.216.525 1.908v1.341h2.917a.836.836 0 00.833-.833v-.475c0-.675-.4-1.275-1.017-1.541zM15.533 15.791a8.703 8.703 0 00-3.533-.75 8.842 8.842 0 00-3.533.75A2.49 2.49 0 007 18.075v.508c0 .459.375.834.833.834h8.334a.836.836 0 00.833-.834v-.508a2.49 2.49 0 00-1.467-2.284z","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.5 11.917c0 1.383 1.117 2.5 2.5 2.5s2.5-1.117 2.5-2.5c0-1.384-1.117-2.5-2.5-2.5a2.497 2.497 0 00-2.5 2.5zM5.333 15.25a1.667 1.667 0 100-3.333 1.667 1.667 0 000 3.333zM3.017 16.567A1.675 1.675 0 002 18.108v.475c0 .459.375.834.833.834H5.75v-1.342c0-.692.192-1.342.525-1.909a5.819 5.819 0 00-.942-.083c-.825 0-1.608.175-2.316.484zM20.333 13.583a1.667 1.667 0 11-3.333 0 1.667 1.667 0 013.333 0z","fill":"#fff"}})])
          )
        }
      }
    